import React, { FC, useState } from 'react';
import { Text, View } from 'react-native';
import ModalHeader from '@components/modal/ModalHeader';
import { scale as initialScale, selectedZoomOPIndex, setSelectedZoomOPIndex } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import SliderWeb from '@components/operatorPanel/components/elements/SliderWeb';
import { isWeb, setSecureValue } from '@helpers';
import SliderMobile from '@components/operatorPanel/components/elements/SliderMobile';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { WithColor } from '@styles/colors';
import { trackEvent, TRACKING_EVENTS } from '@services/tracking';

interface OperatorPanelSettingsTextSizeModalProps extends WithColor {
  hide: () => void;
  scale?: ScaleFunction;
  font?: typeof initialFont;
  forceRerenderSettingsPage: () => void;
}

const OperatorPanelSettingsTextSizeModal: FC<OperatorPanelSettingsTextSizeModalProps> = ({
  C,
  hide,
  scale = initialScale,
  font = initialFont,
  forceRerenderSettingsPage,
}) => {
  const [zoomOPIndex, setZoomOPIndex] = useState<number>(selectedZoomOPIndex);
  const [cachedZoomOPIndex, setCachedZoomOPIndex] = useState<number>(selectedZoomOPIndex);
  const [mobileSliderOpacity, setMobileSliderOpacity] = useState<number>(0);

  const onChange = async (value: number | number[]) => {
    const updatedValue = Array.isArray(value) ? value[0] : value;
    setZoomOPIndex(updatedValue);
    setSelectedZoomOPIndex(updatedValue);
    forceRerenderSettingsPage();
  };

  const onSubmit = async () => {
    trackEvent(TRACKING_EVENTS.SETTINGS, {
      action: 'textSizeChanged',
      oldZoomIndex: cachedZoomOPIndex,
      newZoomIndex: zoomOPIndex,
    });
    setCachedZoomOPIndex(zoomOPIndex);
    setSelectedZoomOPIndex(zoomOPIndex);
    setSecureValue('zoomOPIndex', zoomOPIndex.toString());
  };

  const onCancel = () => {
    setSelectedZoomOPIndex(cachedZoomOPIndex);
    forceRerenderSettingsPage();
  };

  const sliderProps = {
    C,
    sliderWidth: 572,
    scale,
    onChange,
    min: 0,
    max: 6,
    value: selectedZoomOPIndex,
    mobileSliderOpacity,
    setMobileSliderOpacity,
  };

  const SliderComponent = isWeb ? <SliderWeb {...sliderProps} /> : <SliderMobile {...sliderProps} />;

  return (
    <View>
      <ModalHeader
        C={C}
        onCancel={() => {
          onCancel();
          hide();
        }}
        onSubmit={() => {
          onSubmit();
          hide();
        }}
        title="Size"
      />
      <View style={{ height: 1, width: '100%', backgroundColor: C('Hairline/ Light/Secondary'), marginTop: scale(16) }} />

      <View
        style={{
          paddingHorizontal: scale(34),
          height: scale(115),
          justifyContent: 'center',
        }}
      >
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(15), width: scale(632), opacity: isWeb ? 1 : mobileSliderOpacity }}>
          <Text style={[font['Button 1'], { color: C('Label/Light/Tertiary') }]}>A</Text>
          {SliderComponent}
          <Text style={[font['Title 1'], { color: C('Label/Light/Tertiary') }]}>A</Text>
        </View>
      </View>
    </View>
  );
};

export default OperatorPanelSettingsTextSizeModal;
